module.exports = __webpack_public_path__ + "img/blue_stripes_bg_v2.a9f5fa62.jpg";